/* DO NOT MODIFY. This is an autogenerated file. */
/* eslint-disable */
import * as React from "react"
import type { SVGProps } from "react"

export const SvgRectangle02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "100%"}
    height={props.height || "100%"}
    fill="none"
    viewBox="0 0 137 20"
    data-name="SvgRectangle02"
    {...props}
  >
    {props.children}
    <path
      fill="#fff"
      d="M.24 1.648A1 1 0 0 1 1.002 0H127.72a2 2 0 0 1 1.549.734L136.84 10l-7.572 9.266a2 2 0 0 1-1.549.734H1.002a1 1 0 0 1-.762-1.648L7.34 10z"
    />
    <path
      fill="#fff"
      fillOpacity={0.2}
      d="M.24 1.648A1 1 0 0 1 1.002 0H127.72a2 2 0 0 1 1.549.734L136.84 10l-7.572 9.266a2 2 0 0 1-1.549.734H1.002a1 1 0 0 1-.762-1.648L7.34 10z"
    />
  </svg>
)
